// @ts-nocheck
/* eslint-disable */
import { makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import Scene from "~/scene";
import { IPoi } from "~/interfaces";
import { store } from "~/state/store";
import { description } from "~/util/providers/poiagg";
import { frpc } from "~/util/general";

const MAX_BEST_REVIEWS_COUNT = 3;

/**
 * @class Hledací požadavek
 * @signal search-request
 * @signal search-response
 * @signal search-abort
*/
export default class Search {
	_bestReviewsCount: number;

	_frpcData: ReturnType<typeof frpc>;

	/**
	 * Provede hledací dotaz.
	 * @param {string} query Dotaz
	 * @param {object} [options]
	 * @param {int} [options.pageSize=10]
	 * @param {int} [options.limit=100]
	 * @param {string} [options.url]
	 * @param {int} [options.zoom] Zoom
	 * @param {number} [options.clusterSize=0] Velikost shluku ve stupních
	 * @param {SceneCoords[]} [options.viewport] Levá dolní a pravá horní souřadnice
	 * @param {int} [options.page] Stránka
	 */
	constructor(query, options) {
		this._callback = null;
		this._results = null; /* vsechny odpovedi */
		this._clusters = []; /* shluky */
		this._page = -1;
		this._frpcData = null;
		this._remainingDescriptions = 0;
		this._responseDescriptions = this._responseDescriptions.bind(this);
		this._responseError = this._responseError.bind(this);
		this._query = query;
		this.resultStatus = -1;
		this.descriptionStatus = -1;
		this._totalCount = 0;
		this._bestReviewsCount = 0;

		this._options = {
			url: CONFIG.requestUrl + "/search",
			zoom: null,
			viewport: null,
			geom: null,
			page: 0,
			limit: 100,
			clusterSize: 0,
			pageSize: 10,

		}
		for (var p in options) { this._options[p] = options[p]; }

		this._meta = {
			query: query,
			adranum: null,
			near: null,
			geolocation: null,
			noLocQuery: null,
			queryLoc: null,
			hasCategory: false,
		};
		this._action = null;
		this._queryType = "";
		this._filters = null;

		this._correctionItems = {
			status: "",
			correctedQuery: "",
			shouldQuery: "",
			items: [],
			quote: []
		};
		this._correction = Object.assign({}, this._correctionItems);

		const { user } = store.getState().user;

		var options = {
			allowCorr: true,
			autoCorr: true,
			personalize: user.state === "green" ? 1 : 0,
		};
		var hints = {};
		if (this._options.zoom) { options.zoom = this._options.zoom; }
		if (this._options.geom) { options.geom = this._options.geom; }
		if (this._options.viewport) {
			var v = this._options.viewport;
			options.fromLongitude = v[0].toWGS84()[0];
			options.toLongitude = v[1].toWGS84()[0];
			options.fromLatitude = v[0].toWGS84()[1];
			options.toLatitude = v[1].toWGS84()[1];
			hints["1.fromLongitude"] = "float";
			hints["1.toLongitude"] = "float";
			hints["1.fromLatitude"] = "float";
			hints["1.toLatitude"] = "float";
		}
		if (this._options.zoom) { options.zoom = this._options.zoom; }
		if (this._options.clusterSize) {
			options.clusterSize = this._options.clusterSize;
			hints["1.clusterSize"] = "float";
		}
		if (this._options.preservePois) { options.preservePois = this._options.preservePois; }
		if (this._options.filter) { options.filter = true; }
		if (this._options.filterMultimarker) { options.filterMultimarker = this._options.filterMultimarker; }
		if (this._options.limit) { options.limit = this._options.limit; }
		this._additionalOptions = options;
		if (!this._additionalOptions.lang) {
			this._additionalOptions.lang = CONFIG.langPriority;
		}
		if (this._options.noCorr) { this._additionalOptions.allowCorr = false; }
		if (this._options.listCategory) {this._additionalOptions.listCategory = this._options.listCategory;}
		if (this._options.correction) {this._additionalOptions.correction = this._options.correction;}
		if (this._options.filters) { this._additionalOptions.userActions = this._options.filters; }
		this._hints = hints;
	}

	$destructor() {
		this.abort();
	}

	/**
	 * provede vlastni hledani
	 * @param {function} callback
	 */
	search(callback) {
		this._callback = callback;
		makeEvent("search-request", this);

		this._frpcData = frpc({
			url: this._options.url,
			method: "complexSearch",
			args: [this._query, this._additionalOptions],
			hints: this._hints,
		});
		this._frpcData.promise.then(data => this._response(data, data.status), data => {
			if (data) {
				this._response(data, data.status);
			} else {
				this._response(null);
			}
		});
	}

	getOptions() {
		return this._options;
	}

	/**
	 * Vrátí opravu překlepů
	 */
	getCorrection() {
		return this._correction;
	}

	abort(onlyRequestAbort) {
		if (this._frpcData) {
			this._frpcData.request.abort();
			this._frpcData = null;

			makeEvent("search-response", this);
			makeEvent("search-abort", this);
		}

		if (!onlyRequestAbort) {
			this._callback = null;
		}
	}

	getAllResults() {
		return this._results;
	}

	/**
	 * Vrátí stránku výsledků. Každý výsledek je objekt s vlasnostmi
	 * source, id, title. description, address, ready, coords
	 */
	getResults() {
		if (!this._results) { return this._results; }

		var page = [];
		if (this._page == -1) { return page; }
		var start = this._page * this._options.pageSize;
		var end = Math.min(this._results.length, start + this._options.pageSize);
		for (var i=start; i<end; i++) { page.push(this._results[i]); }
		return page;
	}

	/**
	 * Vrátí všechny shluky
	 */
	getClusters() {
		return this._clusters;
	}

	/**
	 * Nastaví stránku výsledků a optá se na upřesnění
	 */
	setPage(page, origin = "") {
		var pages = Math.ceil(this._results.length / this._options.pageSize);
		if (page >= pages) { page = pages-1; } /* zkontrolovat shora */

		this._page = page;
		if (page == -1) {
			this._callback && this._callback(this, origin);
			return;
		}

		var allReady = true;
		var items = []; /* k upresneni */
		var start = this._page * this._options.pageSize;
		var end = Math.min(this._results.length, start + this._options.pageSize);
		for (var i=start; i<end; i++) {
			var item = this._results[i];
			if (item.ready) { continue; }
			allReady = false;
			items.push(item);
		}

		if (allReady) {
			this._callback && this._callback(this, origin);
			return;
		}

		this._requestDescriptions(items, origin);
	}

	/**
	 * Vrátí aktuální stránku
	 */
	getPage() {
		return this._page;
	}

	/**
	 * Vrátí metadata hledání
	 */
	getMeta() {
		return this._meta;
	}

	/**
	 * Vrátí metadata hledání
	 */
	getAction() {
		return this._action;
	}

	/**
	 * Vrátí filtry pro aktulani hledani
	 */
	getFilters() {
		return this._filters;
	}

	/**
	 * Vrátí hledaný výraz
	 */
	getQuery() {
		return this._query;
	}

	getQueryType() {
		return this._queryType;
	}

	/**
	 * Vrátí celkový počet výsledků
	 */
	getTotalCount() {
		return this._totalCount;
	}

	getDetailData() {
		const action = this.getAction();
		const isDetail = action && action.type === "detail" && action.immediate;

		return isDetail ? this.getResults()[action.args.index] : null;
	}

	getBestReview(poiData: IPoi): null | IPoi["reivew"]["best_review"] {
		if (poiData.review?.best_review && this._bestReviewsCount < MAX_BEST_REVIEWS_COUNT) {
			this._bestReviewsCount++;

			return poiData.review.best_review;
		}

		return null;
	}

	/**
	 * Odpověď od serveru
	 */
	_response(data, status = -1) {
		makeEvent("search-response", this);

		this._frpcData = null;
		// prislo neco jineho nez status 200, stejne zavolame callback, abychom mohli zobrazit chybovou hlasku a poslat hit na analytiku
		if (status < 200 || status > 300) {
			this.resultStatus = status;
			this.descriptionStatus = this.resultStatus;
			this._callback && this._callback(this);
			makeEvent("search-response", this);
		} else {
			this._results = this._parseResponse(data);

			this.resultStatus = data.status;
			this.setPage(this._options.page);
		}
	}

	_parseResponse(data) {
		var results = [];
		this._meta.adranum = data.adraNum;
		this._meta.geolocation = data.geolocation;
		this._meta.noLocQuery = data.noLocQuery;
		this._meta.queryLoc = data.queryLoc;
		this._meta.hasGeo = data.hasGeo;
		this._meta.hasService = data.hasService;
		this._meta.deletedfromBack = data.deletedfromBack;
		this._meta.categoryOnly = data.categoryOnly;
		this._meta.hasCategory = !!data.hasCategory;
		this._meta.detectedQueryLanguage = data.detectedQueryLanguage;
		this._totalCount = data.totalCount || 0;

		if (data.result) {
			let r = data.result;
			for (let i = 0; i < r.length; i++) {
				const result = r[i];
				result.coords = Scene.coordsFromWGS84(result.mark.lon, result.mark.lat);
				result.ready = false;
				if (result.source == "coor") { result.id = result.mark.lon+","+result.mark.lat; }

				results.push(result);
			}

			if (data.near) {
				this._meta.near = {
					query: data.near.object.trim(),
					coords: Scene.coordsFromWGS84(data.near.lon, data.near.lat)
				};
			}

			if (data.clusters) { this._clusters = data.clusters; } /* shluky */
			if (data.correction) { this._correction = Object.assign({}, this._correctionItems, data.correction); } /* oprava preklepu */
			this._queryType = data.queryType;
			this._filters = data.userActions;
		}

		this._action = data.action;

		return results;
	}

	_requestDescriptions(items, origin = "") {
		makeEvent("search-request", this);

		const pois = [];

		for (var i=0;i<items.length;i++) { /* rozhazet poie do skupin */
			var poi = items[i];
			if (poi.source == "coor") {
				poi.ready = true;
				continue;
			}

			pois.push(poi);
		}

		const additionalInfo = {
			fetchPhoto: true,
			ratios: ["default", "1x1", "16x9"],
			lang: CONFIG.langPriority,
			query: this._query,
			reviews: true,
			wikimedia: true,
		};

		if (pois.length) {
			description(pois, additionalInfo).then(function(r) {
				this._responseDescriptions(r.result, r.status, r.response, origin);
			}.bind(this), function(r) {
				this._responseError(r);
			}.bind(this));

		}
		else {
			this._responseDescriptions({}, 200, null, origin);
		}
	}

	/**
	 * Přišla upřesnění od POI serveru
	 */
	_responseDescriptions(results, status, response, origin = "") {
		for (var i=0;i<this._results.length;i++) {
			var r = this._results[i];
			var id = r.source+r.id;
			if (id in results) {
				r.ready = true;
				for (var p in results[id]) {
					r[p] = results[id][p];
				}
			}
		}

		this.descriptionStatus = response ? response.status : status;

		makeEvent("search-response", this);
		this._callback && this._callback(this, origin);
	}

	_responseError(response) {
		this.descriptionStatus = response;
		makeEvent("search-response", this);
		this._results = [];
		this._callback && this._callback(this);
	}
}
